/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Not_Yet_Started_DescriptionInputs */

const en_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay tuned for the upcoming surprises and keep an eye for the latest updates!`)
};

const ar_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابقوا على اطلاع بالمفاجآت القادمة وراقبوا أحدث التحديثات!`)
};

const de_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben Sie dran für die kommenden Überraschungen und halten Sie Ausschau nach den neuesten Updates!`)
};

const es_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Estate atento a las próximas sorpresas y a las últimas actualizaciones!`)
};

const fr_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De jolies surprises se préparent, restez connecté pour ne rien manquer!`)
};

const it_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimani sintonizzato per le prossime sorprese e tieni d'occhio gli ultimi aggiornamenti!`)
};

const ja_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今後のサプライズと最新情報にご期待ください！`)
};

const ko_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다가오는 깜짝 소식을 기대해주시고 최신 업데이트도 놓치지 마세요!`)
};

const pt_br_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se liga nas surpresas que estão por vir e fica de olho nas últimas atualizações!`)
};

const ru_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следите за предстоящими сюрпризами и не пропустите последние обновления!`)
};

const th_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอยติดตามเซอร์ไพรส์ที่จะเกิดขึ้นในเร็ว ๆ นี้และจับตาดูการอัปเดตล่าสุด!`)
};

const tr_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan sürprizler için bizi izlemeye devam et ve en son güncellemeleri takip et!`)
};

const zh_cn_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敬请期待精彩活动！记得持续关注我们的最新消息哦！`)
};

const zh_tw_dialog_event_not_yet_started_description = /** @type {(inputs: Dialog_Event_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敬請期待精彩活動！記得持續關注我們的最新消息哦！`)
};

/**
* | output |
* | --- |
* | "Stay tuned for the upcoming surprises and keep an eye for the latest updates!" |
*
* @param {Dialog_Event_Not_Yet_Started_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_not_yet_started_description = /** @type {((inputs?: Dialog_Event_Not_Yet_Started_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Not_Yet_Started_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_not_yet_started_description(inputs)
	if (locale === "ar") return ar_dialog_event_not_yet_started_description(inputs)
	if (locale === "de") return de_dialog_event_not_yet_started_description(inputs)
	if (locale === "es") return es_dialog_event_not_yet_started_description(inputs)
	if (locale === "fr") return fr_dialog_event_not_yet_started_description(inputs)
	if (locale === "it") return it_dialog_event_not_yet_started_description(inputs)
	if (locale === "ja") return ja_dialog_event_not_yet_started_description(inputs)
	if (locale === "ko") return ko_dialog_event_not_yet_started_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_not_yet_started_description(inputs)
	if (locale === "ru") return ru_dialog_event_not_yet_started_description(inputs)
	if (locale === "th") return th_dialog_event_not_yet_started_description(inputs)
	if (locale === "tr") return tr_dialog_event_not_yet_started_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_not_yet_started_description(inputs)
	return zh_tw_dialog_event_not_yet_started_description(inputs)
});